import { EMPTY_STRING } from '@doltech/ui/lib/figma/DolEditor/toolbars/inline-commands/types';
import { DictationWordStatusEnum } from '@doltech/utils/lib/constants';
import { replaceApostropheWithPrimeMark } from '@doltech/utils/lib/normalize';
import { isNil } from 'lodash';
import { flow, Instance, types } from 'mobx-state-tree';

import { DictationWord } from './word.store';
import { compareWord } from '@doltech/utils/lib/word-checker/word-checker.api';

export const DoDictationWord = DictationWord.named('DoDictationWord')
  .props({
    studentValue: types.maybe(types.string),
    status: types.enumeration<DictationWordStatusEnum>(
      'WordStatus',
      Object.values(DictationWordStatusEnum)
    ),
  })
  .views((self) => ({
    get normalizedStudentValue() {
      return replaceApostropheWithPrimeMark(self.studentValue);
    },
  }))
  .actions((self) => {
    const setUntouched = () => {
      self.status = DictationWordStatusEnum.UNTOUCHED;
    };
    return {
      setUntouched,

      setStatus(status: DictationWordStatusEnum) {
        self.status = status;
      },
      setValue(value: string) {
        self.value = value;
      },
      setCorrect() {
        self.status = DictationWordStatusEnum.CORRECT;
      },
      setWrongPosition() {
        self.status = DictationWordStatusEnum.WRONG_POSITION;
      },
      setStudentValue(studentValue: string) {
        self.studentValue = studentValue;

        if (studentValue === EMPTY_STRING || isNil(studentValue)) {
          setUntouched();
        } else {
          self.status = DictationWordStatusEnum.DIRTY;
        }
      },
      check: flow(function* checkWord() {
        if (self.normalizedStudentValue) {
          const isCorrect = yield compareWord({
            word1: self.normalizedStudentValue,
            word2: self.value,
          });
          self.status = isCorrect
            ? DictationWordStatusEnum.CORRECT
            : DictationWordStatusEnum.INCORRECT;
        }
      }),
    };
  })
  .views((self) => {
    return {
      get isUntouched() {
        return self.status === DictationWordStatusEnum.UNTOUCHED;
      },
      get isDirty() {
        return self.status !== DictationWordStatusEnum.UNTOUCHED;
      },
      get isCorrect() {
        return self.status === DictationWordStatusEnum.CORRECT;
      },
      get isWrongPosition() {
        return self.status === DictationWordStatusEnum.WRONG_POSITION;
      },
      get isIncorrect() {
        return self.status === DictationWordStatusEnum.INCORRECT;
      },
    };
  });

export interface DoDictationWordInstance extends Instance<typeof DoDictationWord> {}
